// vim: set ts=2 sts=2 sw=2 et:

import React from "react";
import { useLocation, useParams } from "react-router-dom";

import { parsePlatformRef } from "../operation/platformRef";
import SpectatorContainer from "./SpectatorContainer";

const SpectatorRoute = () => {
  const params = useParams();
  const location = useLocation();
  const platformRef = parsePlatformRef(params.day, params.platformId);

  return <SpectatorContainer platformRef={platformRef} locationSearch={location.search} />;
};

export default SpectatorRoute;
